import { DetailsControlType } from 'shared/details-page/details-control/details-control-type';

/*
  * Structure:
  {
    [columnName]: {
      field_map: string, // control name, used in save request
      item_name: string, // path to the data
      controlType: string, // input, select, etc
      formArray?: boolean, // indicate list of controls
      controls?: Array<{field_map, item_name}>, // controls that should be created inside form array
      displayControl?: string, // control name from FormArray to show on the page
      comingSoon?: boolean // indicate coming soon field (not editable, just display stub)
      nestedArray?: boolean // indicate nested table of controls
      displayControlArray?: Array<string> // control names from FormArray to show on the page (for nested tables)
    }
  }
 */
export const nestedTableEditableColumns: any = {
  'mfrLabel': {
    'fieldMap': 'mfr_label',
    'itemName': 'assignment_values.mfr_label',
    'maxLength': 500,
    'controlType': DetailsControlType.Textarea,
  },
  'notes': {
    'fieldMap': 'notes',
    'itemName': 'assignment_values.notes',
    'formArray': true,
    'maxLength': 500,
    'controlType': DetailsControlType.Textarea,
    'controls': [
      { fieldMap: 'type_id', itemName: 'type_id' },
      { fieldMap: 'value', itemName: 'value' },
    ],
    'displayControl': 'value',
  },
  'partTerminologies': {
    'fieldMap': 'part_terminologies',
    'itemName': 'part_terminologies',
    'formArray': true,
    'maxLength': 500,
    'controlType': DetailsControlType.Input,
    'controls': [
      {
        fieldMap: 'id',
        itemName: 'id',
        title: 'Fitment Part ID',
        width: '25%',
      },
      {
        fieldMap: 'name',
        itemName: 'name',
        title: 'Fitment Part Type',
        width: '25%',
      },
      {
        fieldMap: 'position',
        itemName: 'position',
        title: 'Position',
        width: '25%',
      },
    ],
    'displayControlArray': ['id', 'name', 'position'],
    'nestedArray': true,
  },
  'qualifiers': {
    'fieldMap': 'qualifiers',
    'itemName': 'qualifiers',
    'formArray': true,
    'maxLength': 500,
    'controlType': DetailsControlType.Input,
    'controls': [
      {
        fieldMap: 'id',
        itemName: 'id',
        title: 'Qualifier ID',
        width: '25%',
      },
      {
        fieldMap: 'text_format',
        itemName: 'text_format',
        title: 'Qualifier Text',
        width: '50%',
        type: 'template'
      },
    ],
    'displayControlArray': ['id', 'text'],
    'nestedArray': true,
  },
  'digitalAssets': {
    'comingSoon': true,
  }
};
